import React from 'react';
import PropTypes from 'prop-types';
import { MdMessage } from 'react-icons/md';
import { getCommunityCategories } from '../../utils/api';
import { LocalizationContext } from '../../hoc/Localization';
import Container from '../Home/Container';
import styles from './styles.less';

const Community = ({ param }) => {
  const { t } = React.useContext(LocalizationContext);
  const [community, setCommunity] = React.useState([]);

  React.useEffect(() => {
    (async () => {
      setCommunity((await getCommunityCategories(param)).data);
    })();
  }, [param]);

  return (
    <Container>
      <h2>{t('landing.community.title')}</h2>
      <div className={styles.communityPost}>
        <table>
          <tbody>
            {community &&
              community.children &&
              community.children.map(
                user =>
                  user.posts &&
                  user.posts.map(postitem => (
                    <tr>
                      <a href={`https://course.am/community/topic/${user.posts[0].topic.slug}`}>
                        <td>
                          <img
                            src={
                              postitem.user.picture && postitem.user.picture.includes('https')
                                ? postitem.user.picture
                                : `https://www.course.am/${postitem.user.picture}`
                            }
                            alt={postitem.user.picture}
                          />
                        </td>
                        <td>
                          {postitem.topic.title}
                          <p>
                            <MdMessage className={styles.mdMessage} />
                            <span>{`${user.name} •`}</span>
                            <span>{`${postitem.timestampISO.slice(0, 10)},`}</span>
                            <span>{`${postitem.timestampISO.slice(11, 19)} •`}</span>
                            <span>{postitem.user.username}</span>
                          </p>
                        </td>
                        <td>
                          <span>Posts</span>
                          <span>{`${user.totalPostCount} / `}</span>
                          <span>{user.totalTopicCount}</span>
                        </td>
                      </a>
                    </tr>
                  )),
              )}
          </tbody>
        </table>
      </div>
    </Container>
  );
};

Community.propTypes = {
  param: PropTypes.number,
};
Community.defaultProps = {
  param: '',
};

export default Community;
